import React, { FC } from 'react'
import Hero from './components/Hero'
import ServicesAndBenefits from './components/ServicesAndBenefits'
import Team from './components/Team'
import Intro from './components/Intro'
import QuizCallout from './components/QuizCallout'
import ContactUs from './components/ContactUs'
import Carousel from './components/Carousel'
import ChooseAA from './components/ChooseAA'
import styles from './components/ArtAdvisory.module.scss'

const Component: FC = () => {
  return (
    <div className={styles.artAdvisory}>
      <Hero />
      <Intro />
      <ServicesAndBenefits />
      <ChooseAA />
      <QuizCallout />
      <Carousel />
      <Team />
      <ContactUs />
    </div>
  )
}

export default Component
